export const CLEAR_TENANTS = 'CLEAR_TENANTS';
export const FETCH_TENANTS_START = 'FETCH_TENANTS_START';
export const FETCH_TENANTS_SUCCESS = 'FETCH_TENANTS_SUCCESS';
export const FETCH_TENANTS_FAILURE = 'FETCH_TENANTS_SUCCESS';
export const FETCH_TENANT_BY_ID_START = 'FETCH_TENANT_BY_ID_START';
export const FETCH_TENANT_BY_ID_SUCCESS = 'FETCH_TENANT_BY_ID_SUCCESS';
export const FETCH_TENANT_BY_ID_FAILURE = 'FETCH_TENANT_BY_ID_FAILURE';
